export const AUTH_CHANGE = 'AUTH_CHANGE'
export const FETCH_USER = 'FETCH_USER'
export const TOGGLE_LOGIN = 'TOGGLE_LOGIN'
export const AUTH_LOADING = 'AUTH_LOADING'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
